function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1A1A1A"
    },
    width: 450,
    height: 450
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 25,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1,
    height: 400
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.049,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.099,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.149,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.199,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.248,
    y: 24.5,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.299,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.349,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.399,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.449,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.498,
    y: 24.5,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.549,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.599,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.648,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.699,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.749,
    y: 24.5,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.799,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.849,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.898,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.003,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.949,
    y: 24.5,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 1.002,
    height: 401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.5,
    y: 25,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1,
    height: 400
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 24.5,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 400,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 44.049,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 64.099,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 84.149,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 104.199,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 124.248,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 144.299,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 164.349,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 184.399,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 204.449,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 224.499,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 244.549,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 264.599,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 284.648,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 304.699,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 324.749,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 344.799,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 364.849,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 384.898,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 404.949,
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 401,
    height: 1.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 424.5,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 400,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 21.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 24.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.5,
    y: 21.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.5,
    y: 24.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 121.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 124.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.5,
    y: 121.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.5,
    y: 124.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 221.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 224.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.5,
    y: 221.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.5,
    y: 224.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 321.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 324.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.5,
    y: 321.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.5,
    y: 324.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 421.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 424.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 21.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 24.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 121.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 124.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 221.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 224.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 321.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 324.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 421.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 424.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 21.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 24.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 121.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 124.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 221.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 224.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 321.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 324.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 421.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 424.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 21.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 24.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 121.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 124.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 221.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 224.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 321.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 324.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 421.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 424.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.5,
    y: 421.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.5,
    y: 424.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 7,
    height: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 74.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.5,
    y: 74.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.5,
    y: 74.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.5,
    y: 74.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 174.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.5,
    y: 174.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.5,
    y: 174.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.5,
    y: 174.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 274.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.5,
    y: 274.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.5,
    y: 274.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.5,
    y: 274.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 374.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.5,
    y: 374.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.5,
    y: 374.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.5,
    y: 374.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPattern);
export default __webpack_public_path__ + "static/media/grid-pattern.7ef376bb8804a143798751d5f2c84b40.svg";
export { ForwardRef as ReactComponent };